import { useEffect } from 'react';
import { initCSM } from '../../utils/initCSM';
/**
 * Initialises the CSM widget when mounted
 */
export var AiCornerAgent = function AiCornerAgent(_ref) {
  var site = _ref.site,
    siteId = _ref.siteId,
    widgetId = _ref.widgetId;
  useEffect(function () {
    initCSM({
      site: site,
      siteId: siteId,
      widgetId: widgetId
    });
  }, [site, siteId, widgetId]);
  return null;
};